import { ColorsStorage } from "../Constant/ColorsStorage";

const generateDifferentThemeColor = ({ channels, brands = [], type }) => {
  let allChannelsColor = [],
    allChannelsBorderColor = [],
    allBrandsColor = [],
    allBrandsBorderColor = [];

  if (type === "dark") {
    allChannelsColor = ColorsStorage.color.fill;
    allChannelsBorderColor = ColorsStorage.color.border;
    allBrandsColor = ColorsStorage.color.brand;
    allBrandsBorderColor = ColorsStorage.color.brand_border;
  } else {
    allChannelsColor = ColorsStorage.secondary_color.fill;
    allChannelsBorderColor = ColorsStorage.secondary_color.border;
    allBrandsColor = ColorsStorage.secondary_color.brand;
    allBrandsBorderColor = ColorsStorage.secondary_color.brand_border;
  }

  let channelsColor = [],
    channelsBorderColor = [],
    brandsColor = [],
    brandsBorderColor = [];

  const startIndex = allChannelsColor.length - channels.length;
  const brandStartIndex = allBrandsColor.length - brands.length;

  channels.forEach((channel, i) => {
    channelsColor.push({
      name: channel,
      color: allChannelsColor[startIndex + i],
    });
    channelsBorderColor.push({
      name: channel,
      color: allChannelsBorderColor[startIndex + i],
    });
  });

  brands.forEach((brand, i) => {
    brandsColor.push({
      name: brand,
      color: allBrandsColor[brandStartIndex + i],
    });
    brandsBorderColor.push({
      name: brand,
      color: allBrandsBorderColor[brandStartIndex + i],
    });
  });

  return {
    fill: channelsColor,
    border: channelsBorderColor,
    brand: brandsColor,
    brand_border: brandsBorderColor,
  };
};

export const getMetricsGraphsColor = ({ metrics }) => {
  const darkThemeColor = generateDifferentThemeColor({
    channels: metrics,
    type: "dark",
  });
  return darkThemeColor;
};
